import { useCallback } from "react"

import { Button } from "react-bootstrap"

import OrderResultRecord from "../../api/OrderResults/OrderResultModel/OrderResultRecord"

interface FormFoxTestANColumnProps {
  row: OrderResultRecord
  prevRow?: OrderResultRecord
  onClick: (row: OrderResultRecord) => void
}

function FormFoxTestANColumn({ row, prevRow = undefined, onClick }: FormFoxTestANColumnProps) {
  const { PersonID, FormFoxTestAN } = row

  // Check if we should display the value (when it's different from previous row or first row)
  const shouldDisplayValue = !prevRow || prevRow.PersonID !== PersonID || prevRow.FormFoxTestAN !== FormFoxTestAN
  const shouldShowAsLink = Boolean(FormFoxTestAN && shouldDisplayValue)

  const handleOnClick = useCallback(() => {
    onClick(row)
  }, [onClick, row])

  if (!shouldShowAsLink) {
    return <div className="text-nowrap ml-1">{shouldDisplayValue ? FormFoxTestAN : ""}</div>
  }

  return (
    <Button variant="underline-link pl-1" onClick={handleOnClick}>
      {FormFoxTestAN}
    </Button>
  )
}

export default FormFoxTestANColumn
